function InitializeSessionRoutiness() {
  setTimeout(SessionKeepAlive, SessionUpdateTime);
}

function SessionKeepAlive() {
  $.ajax({
    type: "POST",
    contentType: "application/json; charset=utf-8",
    dataType: "json",
    url: "/Session.asmx/KeepAlive",
    cache: false,
    success: function (data, textStatus, xhr) {
      // В мобильной версии WebAccess нет.
      try {
        if (WebAccess) {
          $.when(WA.AgentInit).done(function () {
            WebAccess.agent.keepAlive();
          });
        }
      } catch (e) {
        console.log('using WebAccess to keep alive the Agent');
      }
      setTimeout(SessionKeepAlive, SessionUpdateTime);
      if (!WA.services._isSessionAlive(xhr.status)) return;
    },
    error: function (err) {
      setTimeout(SessionKeepAlive, SessionUpdateTime);
      if (!WA.services._isSessionAlive(err.status)) return;
    }
  });
}

function ObjLockKeepAlive(url, data) {
  var R = false;
  var obj = {
    timeout: null //чтобы работала передача по сслыке
  };

  //TODO Почему синхронные запросы?
  $.ajax({
    type: "POST",
    contentType: "application/json; charset=utf-8",
    dataType: "json",
    url: url,
    cache: false,
    async: false,
    data: data,
    success: function (res) {
      R = res.d;
    },
    error: function (err) {
      obj.timeout = setTimeout(function () { ObjLockKeepAlive.call(ObjLockKeepAlive, url, data) }, LockUpdateTime);
      if (!WA.services._isSessionAlive(err.status)) return;
    }
  });
  if (R) {
    obj.timeout = setTimeout(function () { ObjLockKeepAlive.call(ObjLockKeepAlive, url, data) }, LockUpdateTime);
  }

  return obj;
}
